import { Autocomplete, TextField } from "@mui/material";
import React from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import InputLabelCustom from "src/shared/components/forms/InputLabelCustom";
import { isChangeFormSearchState } from "src/SearchHours/state/atoms";
import {
  capitalizeWords,
  finderSpecialityByName,
} from "src/shared/global/helpers";
import {
  disabledSelectState,
  errorsWaitListState,
  professionalWaitListState,
  specialitiesWaitListState,
  specialityWaitListState,
} from "../state/atoms";
import { useSpecialities } from "../hooks/useSpecialities";
import AutocompleteSkeleton from "src/shared/components/skeletons/AutocompleteSkeleton";
import { hourSelectedState } from "src/store/reservation/reservationState";

const AutocompleteSpecialities = ({ size = "small", styles }) => {
  const [hourSelected, setHourSelected] = useRecoilState(hourSelectedState);

  const { loading, specialities } = useSpecialities();

  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  // const [specialities, setSpecialities] = useRecoilState(
  //   specialitiesWaitListState
  // );

  const [specialitySelected, setSpecialitySelected] = useRecoilState(
    specialityWaitListState
  );

  const [professionalSelected, setProfessionalSelected] = useRecoilState(
    professionalWaitListState
  );

  const [errorsWaitList, setErrorsWaitList] =
    useRecoilState(errorsWaitListState);

  const [disableSelect, setDisabledSelect] =
    useRecoilState(disabledSelectState);

  if (loading) return <AutocompleteSkeleton />;

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-especialidad"
        text="Especialidad"
        style={{ ...styles.label }}
      />
      <Autocomplete
        style={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-especialidad"
        options={specialities.map((option) => `${option.espNombre}`)}
        getOptionLabel={(option) => capitalizeWords(option) || null}
        value={specialitySelected.value || null}
        noOptionsText="Sin resultados"
        disabled={disableSelect}
        onChange={(event, value, reason) => {
          setIsChangeFormSearch(true);
          if (reason === "clear") {
            setSpecialitySelected({
              value: "",
              code: null,
            });
            if (!hourSelected) {
              setProfessionalSelected({
                value: "",
                code: null,
              });
            }
            return;
          }

          if (reason === "selectOption") {
            const findSpeciality = finderSpecialityByName(specialities, value);

            setSpecialitySelected({
              value: value,
              code: findSpeciality?.espCodigo || findSpeciality?.esCodigo,
            });

            if (!hourSelected) {
              setProfessionalSelected({
                value: "",
                code: null,
              });
            }
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Buscar"
            variant="outlined"
            error={errorsWaitList.speciality.length > 0}
            helperText={errorsWaitList.speciality}
          />
        )}
      />
    </>
  );
};

export default AutocompleteSpecialities;
